// src/data/defaultBlocklist.js
// Global default blocklist — parents cannot unblock these
// Contact support to modify

export const DEFAULT_BLOCKED_DOMAINS = [
    // Social Media
    'facebook.com', 'www.facebook.com', 'm.facebook.com', 'fb.com',
    'instagram.com', 'www.instagram.com',
    'threads.net', 'www.threads.net',
    'twitter.com', 'www.twitter.com',
    'x.com', 'www.x.com',
    'tiktok.com', 'www.tiktok.com', 'vm.tiktok.com',
    'snapchat.com', 'www.snapchat.com',
    'bere.al', 'be.real',
    'reddit.com', 'www.reddit.com', 'old.reddit.com',
    'linkedin.com', 'www.linkedin.com',
    'pinterest.com', 'www.pinterest.com',
    'tumblr.com', 'www.tumblr.com',
    'vk.com', 'www.vk.com',
    'mastodon.social', 'bsky.app',
    'lemon8-app.com', 'purp.social',
    'yubo.live', 'hoop.photo', 'wizzapp.com',

    // Messaging
    'whatsapp.com', 'www.whatsapp.com', 'web.whatsapp.com',
    'telegram.org', 'www.telegram.org', 'web.telegram.org',
    'discord.com', 'www.discord.com', 'discordapp.com', 'www.discordapp.com',
    'wechat.com', 'web.wechat.com',
    'line.me', 'signal.org', 'viber.com',
    'kik.com', 'imo.im', 'botim.me', 'zangi.com',
    'skype.com', 'web.skype.com',
    'messenger.com',

    // Dating
    'tinder.com', 'bumble.com', 'badoo.com', 'grindr.com',
    'happn.com', 'okcupid.com', 'hinge.co', 'eharmony.com',
    'match.com', 'pof.com', 'zoosk.com',

    // Gambling
    'bet365.com', '888casino.com', '888.com', 'williamhill.com',
    'bwin.com', 'betfair.com', 'codere.com', 'pokerstars.com',
    'betway.com', 'draftkings.com', 'fanduel.com', 'stake.com',

    // Adult
    'onlyfans.com', 'pornhub.com', 'xvideos.com', 'xnxx.com',
    'brazzers.com', 'redtube.com', 'youporn.com', 'xhamster.com',
    'spankbang.com', 'eporner.com',

    // Streaming
    'youtube.com', 'www.youtube.com', 'youtu.be', 'm.youtube.com',
    'twitch.tv', 'netflix.com', 'primevideo.com',
    'disneyplus.com', 'max.com', 'hbomax.com', 'kick.com',

    // Gaming
    'roblox.com', 'minecraft.net', 'epicgames.com', 'fortnite.com',
    'among.us', 'subwaysurfers.com', 'supercell.com',
    'crazygames.com', 'poki.com', 'miniplay.com', 'iogames.space',
    'shellshock.io', 'krunker.io', 'skribbl.io', 'powerline.io',
    'miniroyale.io', 'tacticscore.io', 'warbrokers.io', 'wings.io',
    'agar.io', 'slither.io', 'nightpoint.io', 'surviv.io',
    'collisio.club', 'armorgames.com', 'stardoll.com', 'ladypopular.com',

    // Other
    'quora.com', 'www.quora.com', 'wattpad.com',

    // AI
    'chat.openai.com', 'chatgpt.com', 'claude.ai',
    'gemini.google.com', 'copilot.microsoft.com',
    'character.ai', 'janitorai.com', 'c.ai',
];

// Check if a URL matches any default blocked domain
export function isDefaultBlocked(url) {
    if (!url) return false;
    const clean = url.toLowerCase()
        .replace(/^https?:\/\//, '')
        .replace(/^www\./, '')
        .replace(/\/.*$/, '')
        .trim();

    return DEFAULT_BLOCKED_DOMAINS.some(domain => {
        const cleanDomain = domain.toLowerCase().replace(/^www\./, '');
        return clean === cleanDomain || clean.endsWith('.' + cleanDomain);
    });
}

// Group label for display
export const DEFAULT_BLOCKED_LABEL = 'Default Protected';